<template lang='pug'>
    v-dialog( v-bind='dialogProps' v-model='value' )
        v-toolbar( color='primary' dark flat )
            v-btn( icon @click='close' )
                v-icon close
            v-toolbar-title.title {{ title }}
            v-spacer
            v-toolbar-items( v-if='width < 1' )
                v-btn( flat @click='submit' ) {{ submitText }}
                    v-icon.ml-2 done_all
        crud-data-table( v-bind='tableProps' @selected='$emit( "selected", $event )' )
            template( slot='actions' slot-scope='props' )
                slot( name='table-actions' v-bind='props' )
        v-toolbar( flat v-if='width > 0' )
            v-spacer
            v-btn( color='secondary' @click='submit' ) {{ submitText }}
                v-icon.ml-2 {{ submitIcon }}
</template>

<script>
    //
    import ModelDataTable from './ModelDataTable'
    //
    export default {
        name: "crud-data-table-dialog-picker",
        components: {
            'crud-data-table': ModelDataTable,
        },
        computed: {

            /**
             * 
             */
            dialogProps () {
                return {
                    contentClass: this.width < 1 ? "white" : "",
                    fullscreen  : this.width < 1,
                    transition  : this.transition,
                    width       : this.width,
                }
            },

            /**
             * @description
             * get table selected
             *
             * @return     {<type>}  table selected items
             */
            tableSelected() {
                return this.$refs.table ? this.$refs.table.selected : []
            },

            /**
             * 
             */
            tableProps () {
                return {
                    ...this.tableStatic,
                    attachParams        : this.attachParams,
                    defaultLimit        : this.defaultLimit,
                    editable            : this.editable,
                    filters             : this.filters,
                    headers             : this.headers,
                    initialFilterValues : this.initialFilterValues,
                    mapperFilter        : this.mapperFilter,
                    mapper              : this.mapper,
                    noActions          : this.noActions,
                    noDataText          : this.noDataText,
                    noPagination        : this.noPagination,
                    noSearch            : this.noSearch,
                    paramFilter         : this.paramFilter,
                    paramSearch         : this.paramSearch,
                    rowsPerPage         : this.rowsPerPage,
                    rowsPerPageText     : this.rowsPerPageText,
                    searchPlaceholder   : this.searchPlaceholder,
                    selectedOne         : this.selectedOne,
                    showNativePagination: this.noPagination,
                    service             : this.service,
                }
            },

            /**
             * 
             */
            transition () {
                return this.width > 0 ? 'scale-transition' : 'dialog-bottom-transition'
            },
        },
        created () {

            /**
             * 
             */
            this.tableStatic = {
                checkable   : true,
                noActions   : true,
                noDetail    : true,
                noRemove    : true,
                noExport    : true,
                ref         : 'table',
            }
        },
        data () {
            return {
                dialog: false,
            }
        },
        methods: {

            /**
             * @description
             * close dialog event
             */
            close () {
                this.onClose()
            },

            /**
             * @description
             * Parse table selected items
             */
            parse(items) {
                return items.map(this.parser)
            },

            /**
             * @description
             * Called on close.
             */
            onClose() {
                this.$emit('input' , false)
            },

            /**
             * @description
             * Called on submit.
             */
            onSubmit() {
                this.$emit('submit', { selected: this.parse(this.tableSelected) })
            },

            /**
             * @description
             * submit picker event
             */
            submit () {
                
                // emitt submit event
                this.onSubmit()
                
                // if not no-close, closed ialog
                if (!this.noClose) this.close()
            },
        },
        props: {

            /**
             * @description
             * default params in request
             */
            attachParams: {
                type: Object,
                default: () => ({}),
            },

            defaultLimit: {
                type: [String, Number],
                default: 15,
            },

            /**
             * 
             */
            editable: Boolean,

            /**
             * 
             */
            filters: Array,

            /**
             * 
             */
            headers: Array,

            initialFilterValues: {
                type: Object,
                default: () => ({}),
            },

            /**
             * 
             */
            mapper: [ Boolean, Function ],
            
            /**
             * @description
             * prepend map function to table data filter
             */
            mapperFilter: {
                type: Function,
                default: filter => filter,
            },

            /**
             * 
             */
            noClose: Boolean,

            /**
             * 
             */
            noActions: {
                type: Boolean,
                default: true,
            },
            noDataText: String,

            /**
             * 
             */
            noPagination: {
                type: Boolean,
                default: true,
            },
            
            /**
             * 
             */
            noSearch: {
                type: Boolean,
                default: false,
            },

            /**
             * 
             */
            paramFilter: {
                type: Object,
                default: () => ({}),
            },

            /**
             * 
             */
            paramSearch: {
                type: String,
                default: 'search',
            },

            /**
             * @description
             * Parser selected data
             */
            parser: {
                type: Function,
                default: row => row,
            },

            /**
             * @description
             */
            reducer: {
                type: Function,
                default: (res, cur) => ([
                    ...res,
                    cur,
                ])
            },
            rowsPerPage: {
                type: Number,
                default: 50,
            },

            /**
             * 
             */
            rowsPerPageText: String,

            /**
             * 
             */
            searchPlaceholder: String,

            /**
             * 
             */
            selectedOne: Boolean,

            /**
             * 
             */
            service: Function,

            /**
             * 
             */
            submitIcon: {
                type: String,
                default: 'done_all',
            },

            /**
             * 
             */
            submitText: {
                type: String,
                default: 'confirmar',
            },

            /**
             * 
             */
            title: {
                type: String,
                default: 'Seleccionar',
            },

            /**
             * 
             */
            value: Boolean,

            /**
             * 
             */
            width: {
                type: Number,
                default: () => 0,
            },
        }
    }
</script>

<style scoped>
    .title::first-letter {
        text-transform: capitalize;
    }
</style>
